// extracted by mini-css-extract-plugin
export default {"book_type":"BookType_book_type__5NJxD","book_grid":"BookType_book_grid__MxSqY"};